import {createSlice} from "@reduxjs/toolkit";
import {firestore} from "../../config/firebaseConfig";

const slice = createSlice({
    name: "publications",
    initialState: {
        list: [],
        loading: false,
        cursor: null,
        error: null,
        isInitialized: false,
        hasMore: true
    },
    reducers: {

        startLoading: (state) => {
            state.loading = true;
        },

        hasError: (state, action) => {
            state.error = action.payload;
            console.log(action.payload);
        },

        gotPublications: (state, action) => {
            state.loading = false;
            state.error = null;
            state.isInitialized = true;
            state.list = action.payload.list;
            state.cursor = action.payload.cursor;
            state.hasMore = action.payload.hasMore;
        },


    }
})

export default slice.reducer;

export const {startLoading, hasError, gotPublications} = slice.actions;

export const selectPublication = (state) => state.publication;

export const fetchPublications = ({loadMore = false, limit = 20}) => {
    return async (dispatch, getState) => {
        try {
            dispatch(startLoading())

            const {list} = selectPublication(getState());

            const {docs} = await firestore.collection(`publish`)
                .orderBy('CreatedAt', "desc")
                .limit(limit)
                .get();

            const result = [...docs.map(one => ({id: one.id, ...one.data()}))]

            dispatch(gotPublications({
                list: loadMore ? [...list, ...result] : result,
                cursor: docs[docs.length - 1],
                hasMore: docs.length < limit
            }))

        } catch (e) {
            dispatch(hasError(e))
        }
    }
}